import { useState, useEffect } from 'react';
import api from '../api';
import BackButton from '../components/BackButton';
import { useI18n } from '../i18n/index.jsx';

export default function AdminBroadcast() {
  const [mode, setMode] = useState('broadcast'); // 'broadcast' | 'individual'
  const { t } = useI18n();
  const [message, setMessage] = useState('');
  const [urgent, setUrgent] = useState(false);
  const [userId, setUserId] = useState('');
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [confirmBroadcast, setConfirmBroadcast] = useState(false);

  useEffect(() => {
    if (mode === 'individual') {
      api.get('/admin/users?limit=500').then(r => setUsers(r.data.users || [])).catch(() => {});
    }
  }, [mode]);

  const filteredUsers = users.filter(u => {
    if (!searchQuery) return true;
    const q = searchQuery.toLowerCase();
    return (
      (u.first_name || '').toLowerCase().includes(q) ||
      (u.last_name || '').toLowerCase().includes(q) ||
      (u.telegram_username || '').toLowerCase().includes(q) ||
      String(u.telegram_id).includes(q)
    );
  });

  async function sendPush() {
    if (!message.trim()) return;
    setLoading(true);
    setResult(null);
    try {
      if (mode === 'broadcast') {
        const { data } = await api.post('/notifications/push/broadcast', { message, urgent });
        setResult({ type: 'success', text: `✅ Отправлено: ${data.sent} | Пропущено: ${data.skipped}` });
        setConfirmBroadcast(false);
      } else {
        if (!userId) { setResult({ type: 'error', text: 'Выберите пользователя' }); return; }
        await api.post('/notifications/push/send', { user_id: Number(userId), message, urgent });
        setResult({ type: 'success', text: '✅ Push отправлен!' });
      }
      setMessage('');
    } catch (e) {
      setResult({ type: 'error', text: e.userMessage || 'Ошибка отправки' });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page">
      <BackButton />
      <h1>📢 Push-уведомления</h1>

      {result && (
        <div style={{
          padding: 12, borderRadius: 8, marginBottom: 16,
          background: result.type === 'error' ? 'rgba(220,38,38,0.2)' : 'rgba(16,185,129,0.2)',
        }}>
          {result.text}
          <button onClick={() => setResult(null)} style={{ marginLeft: 8, background: 'none', border: 'none', cursor: 'pointer', color: '#fff' }}>✕</button>
        </div>
      )}

      {/* Mode Toggle */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        <button
          className={`btn ${mode === 'broadcast' ? 'btn-primary' : 'btn-secondary'}`}
          onClick={() => { setMode('broadcast'); setConfirmBroadcast(false); }}
        >
          📢 Всем
        </button>
        <button
          className={`btn ${mode === 'individual' ? 'btn-primary' : 'btn-secondary'}`}
          onClick={() => setMode('individual')}
        >
          👤 Одному
        </button>
      </div>

      {/* Individual: select user */}
      {mode === 'individual' && (
        <div style={{ marginBottom: 16 }}>
          <input
            type="text"
            placeholder="🔍 Поиск по имени или @username..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #333', background: '#1a1a2e', color: '#fff', marginBottom: 8 }}
          />
          <div style={{ maxHeight: 200, overflow: 'auto', borderRadius: 8, border: '1px solid #333' }}>
            {filteredUsers.slice(0, 50).map(u => (
              <div
                key={u.id}
                onClick={() => setUserId(u.id)}
                style={{
                  padding: '8px 12px', cursor: 'pointer',
                  background: userId === u.id ? 'rgba(99,102,241,0.3)' : 'transparent',
                  borderBottom: '1px solid #222',
                }}
              >
                <span style={{ fontWeight: 600 }}>{u.first_name} {u.last_name || ''}</span>
                <span style={{ opacity: 0.5, marginLeft: 8, fontSize: 12 }}>@{u.telegram_username || u.telegram_id}</span>
              </div>
            ))}
          </div>
          {userId && (
            <div style={{ marginTop: 8, color: '#10b981', fontSize: 13 }}>
              ✅ Выбран: {users.find(u => u.id === userId)?.first_name || `ID:${userId}`}
            </div>
          )}
        </div>
      )}

      {/* Message */}
      <textarea
        placeholder="Текст сообщения..."
        value={message}
        onChange={e => setMessage(e.target.value)}
        rows={4}
        style={{
          width: '100%', padding: 12, borderRadius: 8,
          border: '1px solid #333', background: '#1a1a2e', color: '#fff',
          resize: 'vertical', fontSize: 14, marginBottom: 12,
        }}
      />

      {/* Urgent toggle */}
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, cursor: 'pointer' }}>
        <input type="checkbox" checked={urgent} onChange={e => setUrgent(e.target.checked)} />
        <span>🚨 <b>СРОЧНОЕ</b> — большими буквами, нельзя пропустить</span>
      </label>

      {/* Preview */}
      {message && (
        <div style={{
          padding: 12, borderRadius: 8, marginBottom: 16,
          background: urgent ? 'rgba(239,68,68,0.2)' : 'rgba(99,102,241,0.1)',
          border: urgent ? '2px solid #ef4444' : '1px solid #333',
        }}>
          <div style={{ fontSize: 11, opacity: 0.5, marginBottom: 4 }}>Предпросмотр:</div>
          {urgent ? (
            <div style={{ fontWeight: 800, fontSize: 16 }}>
              🚨🚨🚨<br /><br />
              <span style={{ textTransform: 'uppercase' }}>{message}</span>
              <br /><br />🚨🚨🚨
            </div>
          ) : (
            <div>{message}</div>
          )}
        </div>
      )}

      {/* Send */}
      {mode === 'broadcast' && !confirmBroadcast ? (
        <button
          className="btn"
          style={{ background: '#dc2626', width: '100%' }}
          disabled={!message.trim() || loading}
          onClick={() => setConfirmBroadcast(true)}
        >
          📢 Отправить ВСЕМ пользователям
        </button>
      ) : mode === 'broadcast' && confirmBroadcast ? (
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-secondary" style={{ flex: 1 }} onClick={() => setConfirmBroadcast(false)}>
            Отмена
          </button>
          <button
            className="btn"
            style={{ flex: 1, background: '#dc2626' }}
            disabled={loading}
            onClick={sendPush}
          >
            {loading ? '⏳ Отправка...' : '⚠️ ПОДТВЕРДИТЬ'}
          </button>
        </div>
      ) : (
        <button
          className="btn btn-primary"
          style={{ width: '100%' }}
          disabled={!message.trim() || !userId || loading}
          onClick={sendPush}
        >
          {loading ? '⏳ Отправка...' : '📨 Отправить'}
        </button>
      )}
    </div>
  );
}
